module.exports = __webpack_public_path__ + "static/media/spinner.341ad9c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/spinner.svg
// module id = 515
// module chunks = 0